import { render, staticRenderFns } from "./RTapHeader.vue?vue&type=template&id=27a1b21e&scoped=true&"
var script = {}
import style0 from "./RTapHeader.vue?vue&type=style&index=0&id=27a1b21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a1b21e",
  null
  
)

export default component.exports